import { render, staticRenderFns } from "./ElectricityChart.vue?vue&type=template&id=1f6003b7&"
import script from "./ElectricityChart.vue?vue&type=script&lang=ts&"
export * from "./ElectricityChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports